export const normalizeArticles = (raw: string[] | string | null | undefined): string[] => {
    let parts: string[] = [];

    if (Array.isArray(raw)) {
        parts = raw.flatMap(item => String(item).split(','));
    } else if (typeof raw === 'string') {
        parts = raw.split(',');
    }

    const normalized: string[] = [];
    const seen = new Set<string>();

    parts.forEach(part => {
        const article = part.trim();
        if (!article || seen.has(article)) {
            return;
        }
        seen.add(article);
        normalized.push(article);
    });

    return normalized;
};
